
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticPaths, GetStaticProps } from 'next';
import { getStyleGuideProps, type StyleGuideProps, styleGuideSlugs, } from '@/components/style-guides/server';
import StyleGuidePage from '@/components/style-guides/StyleGuidePage';
export default function InteriorDesignStyleGuide(props: StyleGuideProps) {
    return <StyleGuidePage {...props}/>;
}
// English only: other languages redirect to these paths (next.config.mjs).
export const getStaticPaths: GetStaticPaths = async () => ({
    paths: styleGuideSlugs().map((style) => ({
        params: { style },
        locale: 'en',
    })),
    fallback: false,
});
const getStaticProps: GetStaticProps<StyleGuideProps> = async ({ params, locale, }) => {
    const props = getStyleGuideProps(String(params?.style ?? ''));
    if (!props || (locale && locale !== 'en'))
        return { notFound: true };
    return { props };
};

    async function __Next_Translate__getStaticProps__1a1296daac7__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/interior-design-styles/[style]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1296daac7__ as getStaticProps }
  